__webpack_require__.p = "/test-task-margarita/";